<app-toolbar *ngIf="showToolbar"></app-toolbar>
<main class="app-shell">
  <router-outlet></router-outlet>
</main>
